export default function trainingPresentationDirective() {
  return {
    template: require('./training-presentation.html'),
    controller: 'TrainingPresentationController',
    controllerAs: 'trainingPresentationVM',
    bindToController: true,
    scope: {
      media: '=',
      filterText: '=',
    },
    replace: true,
  };
}
